import { render, staticRenderFns } from "./VisitorLocVerification.vue?vue&type=template&id=56afa4e0&scoped=true&"
import script from "./VisitorLocVerification.vue?vue&type=script&lang=js&"
export * from "./VisitorLocVerification.vue?vue&type=script&lang=js&"
import style0 from "./VisitorLocVerification.vue?vue&type=style&index=0&id=56afa4e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56afa4e0",
  null
  
)

export default component.exports